/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockDepletedListResVo } from './AdminStockDepletedListResVo';
import {
    AdminStockDepletedListResVoFromJSON,
    AdminStockDepletedListResVoFromJSONTyped,
    AdminStockDepletedListResVoToJSON,
    AdminStockDepletedListResVoToJSONTyped,
} from './AdminStockDepletedListResVo';

/**
 * 
 * @export
 * @interface PageDataAdminStockDepletedListResVo
 */
export interface PageDataAdminStockDepletedListResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataAdminStockDepletedListResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataAdminStockDepletedListResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataAdminStockDepletedListResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<AdminStockDepletedListResVo>}
     * @memberof PageDataAdminStockDepletedListResVo
     */
    records?: Array<AdminStockDepletedListResVo>;
}

/**
 * Check if a given object implements the PageDataAdminStockDepletedListResVo interface.
 */
export function instanceOfPageDataAdminStockDepletedListResVo(value: object): value is PageDataAdminStockDepletedListResVo {
    return true;
}

export function PageDataAdminStockDepletedListResVoFromJSON(json: any): PageDataAdminStockDepletedListResVo {
    return PageDataAdminStockDepletedListResVoFromJSONTyped(json, false);
}

export function PageDataAdminStockDepletedListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataAdminStockDepletedListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(AdminStockDepletedListResVoFromJSON)),
    };
}

export function PageDataAdminStockDepletedListResVoToJSON(json: any): PageDataAdminStockDepletedListResVo {
    return PageDataAdminStockDepletedListResVoToJSONTyped(json, false);
}

export function PageDataAdminStockDepletedListResVoToJSONTyped(value?: PageDataAdminStockDepletedListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(AdminStockDepletedListResVoToJSON)),
    };
}

